import gql from 'graphql-tag';
import { scheduledSessionParticipantCorrectionFieldsFragment } from '../fragments';

export const submitAutoScoreEntriesMutation = gql`
  mutation SubmitAutoScoreEntries($scheduledSession: ID!, $participant: ID!, $entries: [ScheduledSessionParticipantAutoScoreEntryInput!]!) {
    submitAutoScoreEntries(scheduledSession: $scheduledSession, participant: $participant, entries: $entries) {
      ...ScheduledSessionParticipantCorrectionFields
    }
  }

  ${scheduledSessionParticipantCorrectionFieldsFragment}
`;